<template>
  <v-dialog v-model="show" persistent transition="dialog-bottom-transition">
    <v-card class="mb-0">
      <v-toolbar class="mt-12" dark color="primary">
        <v-btn icon dark @click="show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Consumos</v-toolbar-title>
      </v-toolbar>
      <v-card-text class="wrapper">
        <div class="seccion-consumos">
          <Consumos
            v-if="visible"
            ref="consumos"
            :idTurno="idTurno"
            :nombrePaciente="nombrePaciente"
            @actualizarTotal="actualizarTotalConsumido"
            @seleccionarConsumo="onSeleccionarConsumo"
          />
        </div>
        <div class="seccion-cobros">
          <v-card tile>
            <v-card-text>
              <!-- Botón registrar cobro -->
              <v-row>
                <v-col cols="12">
                  <v-btn color="success" block @click="showNuevoCobroConsumo = true" :disabled="saldoConsumos <= 0">
                    <v-icon left>mdi-currency-usd</v-icon>
                    Registrar Cobro
                  </v-btn>
                </v-col>
              </v-row>

              <!-- Lista de cobros -->
              <v-row class="mt-3">
                <v-col cols="12">
                  <v-chip class="ma-0" label color="transparent" text-color="black">
                    <h4>Cobros de Consumos</h4>
                  </v-chip>
                </v-col>
              </v-row>
              <v-data-table
                v-if="listaCobrosConsumo.length"
                :headers="headersCobros"
                :items="listaCobrosConsumo"
                class="elevation-1"
                :hide-default-footer="true"
                locale="es-ar"
                item-key="idCobro"
                :items-per-page="10000"
                :disable-sort="true"
              >
                <template v-slot:item.estado="{ item }">
                  <v-chip :color="getColorEstado(item.estado)" dark small>{{ item.estado }}</v-chip>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        medium
                        v-on="on"
                        color="red"
                        v-bind="attrs"
                        @click="borrarCobroConsumo(item)"
                        >mdi-delete</v-icon
                      >
                    </template>
                    <span>Eliminar Cobro</span>
                  </v-tooltip>
                </template>
              </v-data-table>
              <v-alert class="mt-2" color="purple" dark outlined v-else dense>
                No hay cobros registrados.
              </v-alert>
            </v-card-text>
          </v-card>
        </div>
        <!-- Resumen abajo de todo, ancho completo -->
        <div class="seccion-resumen">
          <v-row>
            <v-col cols="12" sm="4">
              <div class="importe consumido">Total Consumido: ${{ parseFloat(totalConsumido).toFixed(2) }}</div>
            </v-col>
            <v-col cols="12" sm="4">
              <div class="importe pagado">Total Cobrado: ${{ totalCobradoConsumos.toFixed(2) }}</div>
            </v-col>
            <v-col cols="12" sm="4">
              <div :class="['importe', saldoConsumos > 0 ? 'saldo' : 'consumido']">Saldo: ${{ saldoConsumos.toFixed(2) }}</div>
            </v-col>
          </v-row>
        </div>
      </v-card-text>

      <!-- Dialog Nuevo Cobro Consumo -->
      <v-dialog v-model="showNuevoCobroConsumo" max-width="500" persistent>
        <v-card>
          <v-toolbar dark color="primary" dense>
            <v-toolbar-title>Cobro de Consumos</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="showNuevoCobroConsumo = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="pt-4">
            <v-alert type="info" outlined dense>
              Saldo pendiente: ${{ saldoConsumos.toFixed(2) }}
            </v-alert>
            <v-row>
              <v-col cols="12">
                <v-select
                  :items="formasPago"
                  item-text="nombreFormaPago"
                  item-value="idFormaPago"
                  label="Forma de Pago *"
                  prepend-icon="mdi-currency-usd"
                  v-model="cobroConsumo.formaPago"
                  dense
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="cobroConsumo.total"
                  prepend-icon="mdi-currency-usd"
                  label="Importe *"
                  dense
                  @keypress="onlyNumber"
                  maxlength="10"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="cobroConsumo.observaciones"
                  prepend-icon="mdi-note"
                  label="Observaciones"
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="success"
              :disabled="!cobroConsumo.total || parseFloat(cobroConsumo.total) <= 0 || !cobroConsumo.formaPago"
              @click="guardarCobroConsumo"
            >Guardar</v-btn>
            <v-btn color="error" @click="showNuevoCobroConsumo = false">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </v-dialog>
</template>
<script>
import Consumos from "./Consumos.vue";
import axios from "@/axios-auth";

export default {
  props: {
    visible: {
      required: false,
    },
    idTurno: {
      required: false,
      default: 0,
    },
    nombrePaciente: { type: String, required: false, default: "" },
  },
  data() {
    return {
      totalConsumido: 0,
      idConsumoSeleccionado: null,
      descripcionConsumoSeleccionado: null,
      // Cobros
      showNuevoCobroConsumo: false,
      listaCobrosConsumo: [],
      formasPago: [],
      cobroConsumo: {
        formaPago: null,
        total: null,
        observaciones: "",
      },
      headersCobros: [
        { text: "Fecha", value: "fechaString" },
        { text: "Forma Pago", value: "nombreFormaPago" },
        { text: "Importe", value: "totalString" },
        { text: "Estado", value: "estado" },
        { text: "Acciones", value: "actions", sortable: false },
      ],
    };
  },
  computed: {
    show: {
      get() {
        if (this.visible) {
          this.buscarCobrosConsumo();
          this.cargarFormasPago();
        }
        return this.visible;
      },
      set(value) {
        if (!value) {
          document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
          this.$emit("close");
        }
      },
    },
    totalCobradoConsumos() {
      return this.listaCobrosConsumo
        .filter((c) => c.estado !== "Cancelado")
        .reduce((acc, curr) => acc + curr.total, 0);
    },
    saldoConsumos() {
      return parseFloat(this.totalConsumido) - this.totalCobradoConsumos;
    },
  },
  methods: {
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode != 46) {
        $event.preventDefault();
      }
    },
    onSeleccionarConsumo({ idConsumo, descripcion }) {
      this.idConsumoSeleccionado = idConsumo;
      this.descripcionConsumoSeleccionado = descripcion;
    },
    actualizarTotalConsumido(total) {
      this.totalConsumido = total;
    },
    getColorEstado(estado) {
      if (estado === "Aprobado") return "blue";
      if (estado === "Pendiente") return "red";
      if (estado === "Pendiente - Link Generado") return "orange";
      return "grey";
    },
    buscarCobrosConsumo() {
      if (this.idTurno <= 0) return;
      axios
        .get("/Caja/BuscarCobrosConsumo", {
          params: { idTurno: this.idTurno },
        })
        .then((response) => {
          this.listaCobrosConsumo = response.data || [];
        })
        .catch(() => {
          this.listaCobrosConsumo = [];
        });
    },
    cargarFormasPago() {
      axios.get("/Caja/BuscarFormasPago").then((response) => {
        this.formasPago = response.data || [];
        if (this.formasPago.length > 0 && !this.cobroConsumo.formaPago) {
          this.cobroConsumo.formaPago = this.formasPago[0].idFormaPago;
        }
      });
    },
    guardarCobroConsumo() {
      this.$swal({
        title: "Registrar Cobro",
        text: "¿Desea registrar el cobro de consumos?",
        icon: "success",
        showCancelButton: true,
        background: "#ececec",
        confirmButtonText: "Sí",
        cancelButtonText: "No",
        showCloseButton: true,
      }).then((result) => {
        if (result.value) {
          const datosCobro = {
            fecha: new Date().toISOString(),
            idTurno: this.idTurno,
            idPaciente: null,
            total: parseFloat(this.cobroConsumo.total),
            observaciones: this.cobroConsumo.observaciones || "Cobro de consumos",
            idProfesional: null,
            paciente: this.nombrePaciente || "Consumos del turno",
            idFormaPago: this.cobroConsumo.formaPago,
            usuario: this.$store.state.usuario.usuario,
            idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
            esSena: false,
            esCobroConsumo: true,
          };
          let self = this;
          axios
            .post("/Caja/GuardarCobro", datosCobro)
            .then(() => {
              self.$swal.fire({
                icon: "success",
                title: "Cobro registrado.",
                showConfirmButton: false,
                background: "#ececec",
                timer: 2000,
              });
              self.showNuevoCobroConsumo = false;
              self.cobroConsumo.total = null;
              self.cobroConsumo.observaciones = "";
              self.buscarCobrosConsumo();
            })
            .catch(() => {
              self.$swal.fire({
                icon: "error",
                title: "El cobro no pudo ser registrado.",
                showConfirmButton: false,
                background: "#ececec",
                timer: 2000,
              });
            });
        }
      });
    },
    borrarCobroConsumo(item) {
      this.$swal({
        title: "Borrar Cobro",
        text: "¿Desea borrar el cobro?",
        icon: "warning",
        background: "#ececec",
        showCancelButton: true,
        confirmButtonText: "Sí",
        cancelButtonText: "No",
        showCloseButton: true,
      }).then((result) => {
        if (result.value) {
          let self = this;
          axios
            .get("/Caja/BorrarCobro", {
              params: {
                idCobro: item.idCobro,
                idTurno: this.idTurno,
              },
            })
            .then(() => {
              self.$swal.fire({
                icon: "success",
                title: "Cobro borrado.",
                showConfirmButton: false,
                background: "#ececec",
                timer: 2000,
              });
              self.buscarCobrosConsumo();
            })
            .catch(() => {
              self.$swal.fire({
                icon: "error",
                title: "El cobro no pudo ser borrado.",
                showConfirmButton: false,
                background: "#ececec",
                timer: 2000,
              });
            });
        }
      });
    },
  },
  components: {
    Consumos,
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  display: flex;
  flex-wrap: wrap;
  padding: 0 !important;
  gap: 8px;
}

.seccion-consumos {
  flex: 1 1 55%;
  min-width: 400px;
}

.seccion-cobros {
  flex: 1 1 35%;
  min-width: 300px;
}

.seccion-resumen {
  flex: 1 1 100%;
  padding: 8px;
}

.importe {
  padding: 10px 12px;
  border-radius: 5px;
  color: white;
  font-weight: 600;
  text-align: center;
}
.consumido {
  border: 2px solid rgb(4, 99, 4);
  background: rgb(4, 121, 4);
}
.pagado {
  border: 2px solid rgb(0, 0, 121);
  background: rgb(3, 3, 230);
}
.saldo {
  border: 2px solid rgb(90, 2, 2);
  background: rgb(179, 5, 5);
}

/* Responsive: en pantallas chicas, cobros va abajo */
@media (max-width: 900px) {
  .seccion-consumos,
  .seccion-cobros {
    flex: 1 1 100%;
    min-width: unset;
  }
}
</style>
